/**
 * @file A helper class for dynamically inject an insight.
 * @author Heino Lenting
 */
/**
 * Class for dynamically inject an insight.
 */
var InsightProvider = /** @class */ (function () {
    /**
     * Constructs an InsightProvider
     * @param container The InsightContainerComponent which holds the insights container.
     * @param http The injected Http component to pass through to the insight.
     */
    function InsightProvider(container, http) {
        this.container = container;
        this.http = http;
    }
    return InsightProvider;
}());
export { InsightProvider };
